import DeviceEditPage from './device-edit-page';

export default DeviceEditPage;